module.exports = __webpack_public_path__ + "img/ngrx-stencil.b47d56e1.svg";